<template>
    <div class="about">
        <h1>This is an About page</h1>
    </div>
</template>

<script>
export default {
    components: {
        
    },
    data() {
        return {}
    },
    computed: {}
}
</script>